import React, { useEffect, useState } from 'react'
import { Card, Col, Row, Input, Label, Button } from 'reactstrap'
import { connect } from "react-redux";
import CustomModal from '../../../../../Components/Modals/CustomModal';
import ViewTaskHistory from './ViewTaskHistory';


function MyTaskDataUi(props) {
  const [taskName, setTaskName] = useState();
  const [taskData, setTaskData] = useState()
  const [openTaskTitle, setOpenTaskTitle] = useState(false)
  const [openReferencePopup,setOpenReferencePopup] = useState(false)
  const [referenceText, setReferenceText] = useState();
  const [selectTaskId, setSelectTaskId] = useState([])
  const [hoveredRefId, setHoveredRefId] = useState(null); 

    const handleVivewTask = (taskData) => {
        console.log(taskData)
        setTaskData(taskData)
        props.setViewTaskPopup(true)
    }
    const handleViewTaskTitle = (task) => {
        setTaskName(task)
        setOpenTaskTitle(true)
      }
      const handleViewReference = (task) => {
        if (task.sourceType === "Ticket" && task.sourceId) {
            props.setNotificationsDetails({
                tabs: 2,
                details: `Redirected to Source Ticket Id : ${task.sourceId} (from Task Reference)`,
                action: true,
                searchparams: String(task.sourceId)
            });
    
            return;
        }
    
        // Existing popup behavior
        setReferenceText(task.reference);
        setOpenReferencePopup(true);
    };

    const handleSelectArchivedTasks = (id) => {
    props.setSelectTaskId((prev) =>
      prev.includes(id) ? prev.filter((item) => item !== id) : [...prev, id]
    );
  };
  const getAllSignedOffTaskIds = () => {
    return props.tasksToDisplay
      .filter(task => task.status === 'Signed Off' )
      .map(task => task.SWTeamTaskId);
  };
  const handleSelectAllSignedOff = () => {
    const allIds = getAllSignedOffTaskIds();
    const areAllSelected = allIds.every(id => props.selectTaskId.includes(id));
  
    if (areAllSelected) {
      // Uncheck all
      const remaining = props.selectTaskId.filter(id => !allIds.includes(id));
      props.setSelectTaskId(remaining);
    } else {
      // Select all
      const newSelection = [...new Set([...props.selectTaskId, ...allIds])];
      props.setSelectTaskId(newSelection);
    }
  };

  // Filter agency members based on task's store (IntegerId)
  const getFilteredAgencyMembers = (task) => {
    if (!props.agencyMemberList || !Array.isArray(props.agencyMemberList)) {
      return [];
    }
    
    // If task has no store (IntegerId is null, 0, or undefined), show all agency members
    if (!task.IntegerId || task.IntegerId === 0) {
      return props.agencyMemberList;
    }
    
    // Filter agency members who are mapped to the task's store
    return props.agencyMemberList.filter((member) => {
      // Check if member has storeMappings array and it includes the task's IntegerId
      if (member.storeMappings && Array.isArray(member.storeMappings)) {
        return member.storeMappings.includes(task.IntegerId);
      }
      // If storeMappings is not available, include the member (fallback)
      return true;
    });
  };
    

    return (
        <>
        
            <Col md={12} >
                <div className='mt-1'>
                    <table className="table custom-scroll-table">
                        <thead className='custom-scroll-table thead'>
                        <tr>
                        <th scope="col" className="text-center">
                            <div className='mt-2 d-flex justify-content-center'>
                               { props.statusFilter =='Signed Off'?
                          <span>
                        
                                    <input
                                    type="checkbox"
                                    title="Select All Signed Off"
                                    checked={
                                    getAllSignedOffTaskIds().length > 0 &&
                                    getAllSignedOffTaskIds().every(id => props.selectTaskId.includes(id))
                                    }
                                    onChange={handleSelectAllSignedOff}
                                    style={{ width: '15px', height: '20px' }}
                                />
                                
                          
                          </span>:''}
                           <p className='ml-2 mb-0'>View</p> 
                            </div>
                        </th>

                                <th scope="col" className='text-center'>Priority</th>
                                <th scope="col" className='text-center'>Title</th>
                                <th scope="col" className='text-center'>Status</th>
                                <th scope="col" className='text-center'>Assigned To</th>
                                <th scope="col" className='text-center'>Sign Off</th>
                                <th scope="col" className='text-center'>Planned Start Date</th>
                                <th scope="col"  className='text-center'>Planned End Date</th>
                                <th scope="col" className='text-center'>Created By</th>
                                <th scope="col"  className='text-center'>Completed At</th>
                                <th scope="col" className='text-center'>Reference</th>
                                {/* <th scope="col" className='text-center'>Source Type</th> */}
                                {/* <th scope="col" className='text-center'>Source Id</th> */}

                            </tr>
                        </thead>
                        <tbody >
                            {props.tasksToDisplay &&
                                props.tasksToDisplay.map((task) => (
                                    <tr key={task.SWTeamTaskId}>
                                        <td className="cursor-pointer">
                                            <div className="d-flex justify-content-center">
                                            {task.status === 'Signed Off' && (
                                                    <input
                                                        type="checkbox"
                                                        title="Archive"
                                                        checked={props.selectTaskId.includes(task.SWTeamTaskId)}
                                                        onChange={() => handleSelectArchivedTasks(task.SWTeamTaskId)}
                                                        style={{ width: '15px', height: '20px' }}
                                                    />
                                                    )}
                                                <p className="ml-2 mb-0" onClick={() => handleVivewTask(task)}>
                                                    {task.SWTeamTaskId}
                                                </p>
                                                
                                            </div>
                                        </td>
                                        <td>
                                            <p className='text-center mb-0'>{task.priority}</p>
                                        </td>
                                        <td className="cursor-pointer">
                                            <div className="d-flex">

                                                <p
                                                    className="m-0 comment-paragraph"
                                                    onClick={() => handleViewTaskTitle(task.taskTitle)}
                                                >
                                                    {task.taskTitle}
                                                </p>
                                            </div>
                                        </td>
                                        <td  style={{ backgroundColor: task.rowColor ? task.rowColor : '' }}>
                                            <>
                                                {/* {task.status ==="Completed"? */}
                                                <p className='mb-0 text-center'>{task.status}</p>
                                           
                                            </>

                                        </td>
                                        <td>
                                            <>
                                                {task.status === "Signed Off" ?
                                                    <p className='mb-0 text-center'>{task.assignedName}</p> :
                                                    <>
                                                        {props.assignedLoading === task.SWTeamTaskId ? (
                                                            <p className="mb-0" style={{ color: "#81e94b" }}>
                                                                Updating..
                                                            </p>
                                                        ) : (

                                                            <>
                                                            {task.accountType !== "Agency" && task.accountType !== "Partners"?
                                                            <select
                                                               className="form-control w-100"
                                                               name="assignedto"
                                                               id="assignedto"
                                                               onChange={(e) => {
                                                                   props.handleSubmitHistory(e, task, "assignedTo");
                                                                   props.setAssingedLoading(task.SWTeamTaskId);
                                                               }}
                                                           >
                                                               <option disabled selected value="">-- Assigned to --</option>
                                                               {props.teamMemberList &&
                                                                   props.teamMemberList.map((member) => (
                                                                       <option
                                                                            title={member.email}
                                                                           key={member.employeeId}
                                                                           value={member.employeeId}
                                                                           selected={member.employeeId === task.assignedTo}
                                                                       >
                                                                           {member.employeeName}
                                                                       </option>
                                                                   ))}
                                                           </select>
                                                           :
                                                            <select
                                                           className="form-control w-100"
                                                           name="assignedto"
                                                           id="assignedto"
                                                           onChange={(e) => {
                                                               props.handleSubmitHistory(e, task, "assignedTo");
                                                               props.setAssingedLoading(task.SWTeamTaskId);
                                                           }}
                                                       >
                                                           <option disabled selected value="">-- Assigned to --</option>
                                                           {getFilteredAgencyMembers(task) &&
                                                               getFilteredAgencyMembers(task).map((member) => (
                                                                   <option
                                                                   title={member.email}
                                                                       key={member.id}
                                                                       value={member.id}
                                                                       selected={member.id === task.assignedTo}
                                                                   >
                                                                       {member.name}
                                                                   </option>
                                                               ))}
                                                            </select>
                                                            }
                                                            </>
                                                        )}
                                                    </>
                                                }
                                            </>

                                        </td>
                                        <td className='mb-0 text-center'>{task.verifiedName}</td>
                                        <td className='mb-0 text-center'>{task.plannedStartDate}</td>
                                        <td className='mb-0 text-center'>{task.plannedEndDate}</td>
                                        <td className='mb-0 text-center'>{task.createdBy}</td>
                                        <td className='mb-0 text-center'>{task.completedAt}</td>
                                        <td className="cursor-pointer">
                                          <div className="d-flex">
                                              {task.sourceType === "Ticket" && task.sourceId ? (
                                                  <a
                                                      href="javascript:void(0)"
                                                      style={{
                                                          color: "#337ab7",
                                                          textDecoration: hoveredRefId === task.SWTeamTaskId ? "underline" : "none"
                                                      }}
                                                      onMouseEnter={() => setHoveredRefId(task.SWTeamTaskId)}
                                                      onMouseLeave={() => setHoveredRefId(null)}
                                                      onClick={() => handleViewReference(task)}
                                                      // title="Click to view source ticket"
                                                  >
                                                      {task.reference}
                                                  </a>
                                              ) : (
                                                  <p
                                                      className="m-0 comment-paragraph"
                                                      onClick={() => handleViewReference(task)}
                                                  >
                                                      {task.reference}
                                                  </p>
                                              )}
                                          </div>
                                      </td>
                                        {/* <td className='mb-0 text-center'>{task.sourceType}</td> */}
                                        {/* <td className='mb-0 text-center'>{task.sourceId}</td> */}

                                    </tr>
                                ))}
                        </tbody>
                    </table>
                </div>
            </Col>
            <CustomModal
        header={"Task Title"}
        isOpen={openTaskTitle}
        toggle={() => setOpenTaskTitle(!openTaskTitle)}
        size={"md"}
        className='my-task-custom-module'
      >
        <Card className='card-of-problemarea p-2'>
          <Col md={12} >
            <p className=' mt-1'>{taskName}</p>
          </Col>

        </Card>
      </CustomModal>
      <CustomModal
        header={"Reference"}
        isOpen={openReferencePopup}
        toggle={() => setOpenReferencePopup(!openReferencePopup)}
        size={"md"}
        className='my-task-custom-module'
      >
        <Card className='card-of-problemarea p-2'>
          <Col md={12} >
            <p className=' mt-1'>{referenceText}</p>
          </Col>

        </Card>
      </CustomModal>
      <CustomModal
        header={<>
          <h6>View Task / <b>Task Id :</b>&nbsp;{taskData && taskData.SWTeamTaskId}</h6>
        </>}
        isOpen={props.viewTaskPopup}
        toggle={() => props.setViewTaskPopup(!props.viewTaskPopup)}
        size={"xl"}
        className='my-task-custom-module'
      >
        <>
          <ViewTaskHistory
            store={props.store} setStore={props.setStore}
            action={false}
            setViewTaskPopup={props.setViewTaskPopup}
            setAllUsersTasks={props.setAllUsersTasks}
            setAgencyMemberList={props.setAgencyMemberList}
            agencyMemberList={props.agencyMemberList}
            userData={props.userData}
            loggedUserId={props.loggedUserId}
            teamMemberList={props.teamMemberList}
            statusList={props.taskStatus}
            taskList={props.taskList}
            taskName={taskName}
            viewTaskData={taskData}
            handleCloseCreateTaskPopup={props.handleCloseCreateTaskPopup}
          />
        </>

      </CustomModal>

        </>
    )
}


const mapStateToProps = (state) => {
    return {
        token: state.loggedUser.token,
        accessLevel: state.loggedUser.accessLevel,
        status: state.loggedUser.status,
        error: state.loggedUser.error,

    };
};

export default connect(mapStateToProps)(MyTaskDataUi);
